import { render, staticRenderFns } from "./VulnerabilityScore.vue?vue&type=template&id=35c90201&"
import script from "./VulnerabilityScore.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports